import * as React from "react";
import { LayerManager } from "../service/LayerManager";
export const services = { layerManager: new LayerManager() };
export const ServiceContext = React.createContext(services);
